import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import prerenderPaths from './rendering/public-routes.json';

const container = document.getElementById('root');
const application = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
const prerenderPath = container.getAttribute('data-mm-prerender');
if (prerenderPaths.includes(prerenderPath) && prerenderPath === window.location.pathname) {
  ReactDOM.hydrateRoot(container, application, {
    onRecoverableError: (error) => console.error('Public page hydration failed:', error),
  });
} else {
  ReactDOM.createRoot(container).render(application);
}
// Removes the preloader once React has mounted
window.onload = () => {
  const preloader = document.getElementById('preloader');
  if (preloader) {
    preloader.style.transition = 'opacity 0.5s ease-in-out';
    preloader.style.opacity = '0';
    setTimeout(() => preloader.remove(), 1000);
  }
};


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
